import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';

import { BaseApiService } from './base-api.service';
import { PopupAcknowledgeRequestModel } from '../models/popups/popupAcknowledgeRequest.model';
import { PendingPopupsModel } from '../models/popups/pendingPopups.model';

@Injectable({
  providedIn: 'root',
})
export class PopupService extends BaseApiService {
  public async checkPending(): Promise<PendingPopupsModel> {
    return await lastValueFrom(this.get<PendingPopupsModel>('api/v1/account/popups/pending'));
  }

  public async acknowledge(request: PopupAcknowledgeRequestModel): Promise<void> {
    await lastValueFrom(this.post<void>('api/v1/account/popups/acknowledge', request));
  }
}
